// src/queries/esimBulk/useUploadDetail.ts

import { useQuery } from '@tanstack/react-query';
import type { PageResponse } from '@models/api';
import {
  type GetUploadHistoriesResponse,
  getUploadHistory,
} from '@apis/esimBulk/upload';

/**
 * Fetch a single bulk upload summary by uploadId.
 *
 * This hook is used on the upload detail page to retrieve
 * high-level metadata such as:
 * - stock information
 * - file name
 * - total / OK / failed counts
 * - current upload status
 *
 * The query is executed only when the given uploadId
 * is a valid positive number.
 */
export const useUploadDetail = (uploadId: number) => {
  const enabled = Number.isFinite(uploadId) && uploadId > 0;

  return useQuery<PageResponse<GetUploadHistoriesResponse>, Error>({
    queryKey: ['uploadDetail', uploadId],
    queryFn: () => getUploadHistory(uploadId),
    enabled,
  });
};
